function joinWithBackendUrl(url, params = {}) {
    return params.backendUrl ? `${params.backendUrl}${url}` : url;
}
function buildUrl(urlWithParams, params = {}) {
    const url = urlWithParams.replace(/\/{(\w+)}/g, (match, key) => {
        return params[key] ? `/${params[key]}` : '';
    });
    return joinWithBackendUrl(url, params);
}
function addSearchParamsToUrl(url, params) {
    const searchParams = Object.keys(params).reduce((state, key) => {
        state.push(`${key}=${params[key]}`);
        return state;
    }, []);
    return `${url}?${searchParams.join('&')}`;
}

export { addSearchParamsToUrl, buildUrl };
//# sourceMappingURL=buildUrl.js.map
